import { render } from "./password-reset-success.vue?vue&type=template&id=4918fc31"
import script from "./password-reset-success.vue?vue&type=script&lang=js"
export * from "./password-reset-success.vue?vue&type=script&lang=js"

import "./password-reset-success.vue?vue&type=style&index=0&id=4918fc31&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__